import Guid from "common/values/guid/guid";
import EntityMember from "work/values/entity-member/entity-member";
import moment, { Moment } from "moment";

export interface ProposalReviewerJSON {
  userId: string;
  entityId: string;
  canEdit: boolean;
  dateApproved?: string;
  customMessage?: string;
}

export default class ProposalReviewer {
  canEdit: boolean;
  entityMember: EntityMember;
  dateApproved?: Moment;
  customMessage?: string;

  constructor(
    entityMember: EntityMember,
    canEdit: boolean,
    dateApproved?: Moment,
    customMessage?: string
  ) {
    this.canEdit = canEdit;
    this.entityMember = entityMember;
    this.dateApproved = dateApproved;
    this.customMessage = customMessage;
  }

  public get userId(): Guid {
    return this.entityMember.userId;
  }
  public get entityId(): Guid {
    return this.entityMember.entityId;
  }

  public isEqualTo(other: ProposalReviewer): boolean {
    return this.entityMember.isEqualTo(other.entityMember) &&
      this.canEdit === other.canEdit &&
      this.customMessage === other.customMessage;
  }

  public clone(): ProposalReviewer {
    return new ProposalReviewer(
      this.entityMember.clone(),
      this.canEdit,
      this.dateApproved,
      this.customMessage
    );
  }

  public toJSON(): ProposalReviewerJSON {
    return {
      userId: this.entityMember.userId.toJSON(),
      entityId: this.entityMember.entityId.toJSON(),
      canEdit: this.canEdit,
      dateApproved: this.dateApproved?.toISOString() ?? '',
      customMessage: this.customMessage ?? ''
    }
  }

  public static fromJSON(json: ProposalReviewerJSON): ProposalReviewer {
    return new ProposalReviewer(
      EntityMember.fromJSON({
        userId: json.userId,
        entityId: json.entityId
      }),
      json.canEdit,
      json.dateApproved ? moment(json.dateApproved) : undefined,
      json.customMessage
    );
  }
}
